module.exports = __webpack_public_path__ + "static/media/app-store.481df0e0.svg";